import {Component, OnInit} from '@angular/core';
import {HttpService} from 'src/app/services/http.service';
import {Router} from '@angular/router';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'terra-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {
  constructor(private http: HttpService, private router: Router, private titleService: Title) {
  }

  ngOnInit() {
    this.titleService.setTitle('Maintenance');
    this.http.get('Utils/Version').subscribe(
      (version: string) => {
        this.router.navigateByUrl('/');
      },
      error => {
      }
    );
  }
}
